<eidos-icon *ngIf="inDebugMode" [iconConfiguration]="emptyIcon" [tooltip]="'debug_info.open'"
  (click)="openDebugObjInfo()" [clickable]="true"></eidos-icon>